<script lang="ts">
	//UI
	import { DefaultLoading } from "@hitit/new_ui/src";

	//Image
	import card from "@hitit/hub/src/assets/Icons/order_detail_card.png";
	import cash from "@hitit/hub/src/assets/Icons/order_detail_cash.png";
	import unknown from "@hitit/hub/src/assets/Icons/order_detail_unknown.png";

	//Utils
	import type { OrderData, PaymentData } from "@hitit/api";
	import type { AxiosResponse } from "axios";
	import { formatNumber } from "@hitit/utils";
	import { t } from "@hitit/hub/src/stores";

	export let orderResponse: OrderResponse;
	export let paymentResponse: PaymentResponse;
	export let orderDTO: OrderData;

	type OrderResponse = Promise<AxiosResponse<{ orderDTO: OrderData }>>;
	type PaymentResponse = Promise<AxiosResponse<{ paymentDTOs: PaymentData[] }>>;

	function getPaymentImage(paymentMethod: string) {
		if (paymentMethod === "INSTORE_CASH") {
			return cash;
		} else if (paymentMethod === "INSTORE_CAT") {
			return card;
		} else {
			return unknown;
		}
	}

	async function loadPayments(paymentResponse: PaymentResponse) {
		const r = await paymentResponse;
		return r.data.paymentDTOs.filter(
			(v) => v.paymentStatus === "PAID" || v.paymentStatus === "REFUNDED"
		);
	}

	function getCardInfo(payment: PaymentData) {
		const transaction = payment.paymentTransactionDTOs?.find(
			(v) => v.success && v.catResponseDTO?.maskedCardNumber
		);
		if (!transaction) return $t("hub.order.no_card_numb");
		return `${transaction.catResponseDTO!.cardCompany} ${
			transaction.catResponseDTO!.maskedCardNumber
		}`;
	}

	function getCashReceiptInfo(payment: PaymentData) {
		const transaction = payment.paymentTransactionDTOs?.find(
			(v) => v.success && v.catResponseDTO?.maskedCardNumber
		);
		if (!transaction) return $t("hub.order.cash_receipt.not_issued");
		return `${$t("hub.order.cash_receipt.cash_receipt")} ${
			transaction.catResponseDTO!.cardCompany === "SODEK_GONGJAE"
				? $t("hub.order.cash_receipt.income_deduction")
				: $t("hub.order.cash_receipt.proof_of_expenditure")
		} ${transaction.catResponseDTO!.maskedCardNumber}`;
	}

	function getType(paymentMethod: string) {
		if (paymentMethod === "INSTORE_CAT") {
			return "hub.order.payment_type.card";
		} else if (paymentMethod === "INSTORE_CASH") {
			return "hub.order.payment_type.cash";
		} else {
			return "?";
		}
	}

	function getTotalPayment(payment: PaymentData) {
		let sum = 0;
		console.log(payment);
		for (let transaction of payment?.paymentTransactionDTOs || []) {
			sum += transaction.totalReceivedPrice;
		}
		return sum;
	}

	function computeFuckingDiscount(orderDTO: OrderData) {
		const areYouSure = orderDTO.discount;
		const inverseCalculation = (orderDTO.itemDTOs || []).reduce((prev, cur) => {
			const iRealyHate = prev + cur.discount;
			const iWantRest = (cur.optionDTOs || []).reduce((prev, cur) => {
				const whatTheFuckThis3DepthCalculation = (
					cur.optionItemDTOs || []
				).reduce((prev, cur) => {
					return prev + cur.discount;
				}, 0);
				return prev + whatTheFuckThis3DepthCalculation;
			}, 0);
			return iRealyHate + iWantRest;
		}, 0);
		return areYouSure + inverseCalculation;
	}

	function computeRedeemdPoint(order: OrderData) {
		const redeemdValue = order.orderRewardDTO?.redeemed?.reward || 0;
		return Math.abs(redeemdValue);
	}

	$: paymentProsmise = loadPayments(paymentResponse);

</script>

<div class="container">
	<span class="short-id">{orderDTO.shortid}</span>
	<div class="item-list card">
		<div class="header row">
			<div class="col product">{$t('hub.order.item')}</div>
			<div class="col price">{$t('hub.order.item_price')}</div>
			<div class="col count">{$t('hub.order.item_count')}</div>
			<div class="col total">{$t('hub.order.item_amount')}</div>
		</div>
		<div class="seperate-bar" />
		<div class="body">
			{#await orderResponse}
				<div class="loading">
					<DefaultLoading />
				</div>
			{:then orderResponse}
				{#each orderResponse.data.orderDTO.itemDTOs || [] as itemDTO}
					<div class="row">
						<div class="col product">
							<p>{itemDTO.name}</p>
						</div>
						<div class="col price">
							<p>{formatNumber(itemDTO.unitPrice)}</p>
						</div>
						<div class="col count">
							<p>{formatNumber(itemDTO.quantity)}</p>
						</div>
						<div class="col total">
							<p>{formatNumber(itemDTO.unitPrice * itemDTO.quantity)}</p>
						</div>
					</div>
					{#each itemDTO.optionDTOs || [] as optionDTO}
						{#each optionDTO.optionItemDTOs || [] as optionItemDTO}
							<div class="row option">
								<div class="col product">
									<p>{optionItemDTO.name}</p>
								</div>
								<div class="col price">
									<p>{formatNumber(optionItemDTO.unitPrice)}</p>
								</div>
								<div class="col count">
									<p>{formatNumber(optionItemDTO.quantity)}</p>
								</div>
								<div class="col total">
									<p>
										{formatNumber(optionItemDTO.unitPrice * optionItemDTO.quantity)}
									</p>
								</div>
							</div>
							{#if optionItemDTO.discount}
								<div class="row option optionDiscount">
									<div class="col product">
										{$t('global.Individual_Discount')}
									</div>
									<div class="col price" />
									<div class="col count" />
									<div class="col total">
										-{formatNumber(optionItemDTO.discount)}
									</div>
								</div>
							{/if}
						{/each}
					{/each}
					{#if itemDTO.discount}
						<div class="row option itemDiscount">
							<div class="col product">{$t('global.Individual_Discount')}</div>
							<div class="col price" />
							<div class="col count" />
							<div class="col total">-{formatNumber(itemDTO.discount)}</div>
						</div>
					{/if}
				{/each}
			{/await}
		</div>
	</div>
	<div class="payment-wrapper">
		{#await paymentProsmise}
			<div class="payment-card card">
				<div class="loading">
					<DefaultLoading />
				</div>
			</div>
		{:then paymentDTOs}
			{#each paymentDTOs as paymentDTO}
				<div class="payment-card card">
					<img src={getPaymentImage(paymentDTO.paymentMethod)} alt="" />
					<div class="payment-info-wrapper">
						<div class="type">{$t(getType(paymentDTO.paymentMethod))}</div>
						<div class="card-no">
							{#if paymentDTO.paymentMethod === 'INSTORE_CAT'}
								{getCardInfo(paymentDTO)}
							{:else if paymentDTO.paymentMethod === 'INSTORE_CASH'}
								{getCashReceiptInfo(paymentDTO)}
							{/if}
						</div>
						<div class="total">
							{#if paymentDTO.paymentStatus === 'PAID'}
								{formatNumber(getTotalPayment(paymentDTO))}{$t('global.KRW')}
							{:else if paymentDTO.paymentStatus === 'REFUNDED'}
								{$t('hub.order.refund')}
							{:else}-{/if}
						</div>
					</div>
				</div>
			{:else}
				<div class="payment-card card">
					<img src={unknown} alt="" />
					<div class="payment-info-wrapper">
						<div class="type">{$t('hub.order.no_payment')}</div>
					</div>
				</div>
			{/each}
		{/await}

		<div class="total-receipt card">
			{#await orderResponse}
				<div class="loading">
					<DefaultLoading />
				</div>
			{:then orderResponse}
				<div class="detail-price">
					{#if computeRedeemdPoint(orderResponse.data.orderDTO) !== 0}
						<div class="row">
							<span>{$t('hub.order.redeemed')}</span>
							<span>{formatNumber(computeRedeemdPoint(orderResponse.data.orderDTO))}{$t('global.KRW')}</span>
						</div>
					{/if}
					<div class="row">
						<span>{$t('global.Discount(Individual+Alpha)')}</span>
						<span>{formatNumber(computeFuckingDiscount(orderResponse.data.orderDTO))}{$t('global.KRW')}</span>
					</div>
					<div class="row">
						<span>{$t('hub.order.total_before_tax')}</span>
						<span>{formatNumber(orderResponse.data.orderDTO.totalPriceBeforeTax)}{$t('global.KRW')}</span>
					</div>
					<div class="row">
						<span>{$t('hub.order.tax')}</span>
						<span>{formatNumber(orderResponse.data.orderDTO.totalTax)}{$t('global.KRW')}</span>
					</div>
				</div>
				<div class="seperate-bar" />
				<div class="row grand-total">
					<span>{$t('hub.order.total')}</span>
					<span>{formatNumber(orderResponse.data.orderDTO.grandTotalPrice)}{$t('global.KRW')}</span>
				</div>
			{/await}
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	/* mobile First */
	div {
		box-sizing: border-box;
	}

	.card {
		border-radius: 5px;
	}
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 20px 10px;
		background-color: #e6e7ed;

		.loading {
			width: 30px;
			height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto;
		}

		.seperate-bar {
			width: 100%;
			height: 1px;
			background-color: #e6e7ec;
			margin: 5.5px 0px;
		}

		.short-id {
			font-weight: 550;
			color: #46474b;
		}

		.card {
			width: 100%;
			padding: 10px;
			background-color: white;
			.row {
				display: flex;
			}
		}

		.payment-wrapper {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;
			@include appleAdjustTextForSize(14, false);
		}

		.payment-card {
			display: flex;
			gap: 10px;
			color: #46474b;
			.type,
			.total {
				font-weight: 500;
			}

			.total {
				font-size: 1.25rem;
			}
			img {
				width: 30px;
				height: 22.2px;
				object-fit: contain;
			}

			.payment-info-wrapper {
				display: flex;
				flex-grow: 1;
				flex-wrap: wrap;
				gap: 10px;
				padding-top: 3px;
				.type,
				.total {
					@include heightRelativeToFontSize(16);
				}
				.card-no {
					flex-basis: 100%;
				}
			}
		}

		.item-list {
			display: flex;
			flex-direction: column;
			@include appleAdjustTextForSize(16);

			.header {
				color: #6d6f76;
			}

			.body {
				display: flex;
				flex-direction: column;
				gap: 10px;
				color: #46474b;
				.row {
					.col {
						word-wrap: break-word;
						text-align: center;
					}
				}
			}

			.row {
				gap: 10px;
				&.option {
					font-size: 0.875rem;
					color: #6d6f76;
				}

				p {
					width: 100%;
				}

				.col {
					display: flex;
					justify-content: center;
				}

				.product {
					flex-grow: 211;
					max-width: calc((100% - 30px) * (211 / 619));
				}
				.price {
					flex-grow: 164;
					max-width: calc((100% - 30px) * (164 / 619));
				}
				.count {
					flex-grow: 80;
					max-width: calc((100% - 30px) * (80 / 619));
				}
				.total {
					flex-grow: 164;
					max-width: calc((100% - 30px) * (164 / 619));
				}
			}
		}
	}

	.total-receipt {
		.detail-price {
			display: flex;
			flex-direction: column;
			gap: 10px;
			color: #6d6f76;
		}
		.row {
			justify-content: space-between;
		}

		.grand-total {
			font-weight: 500;
			color: #46474b;
			@include popinsAdjustTextForSize(20, true);
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			gap: 15px;
			font-size: 1.25rem;
			flex-wrap: wrap;
			padding: 20px;
			.short-id {
				display: none;
			}

			.card {
				width: auto;
				padding: 20px;
			}

			.item-list {
				@include appleAdjustTextForSize(16, false);
				flex-grow: 729;
				width: calc((100% - 30px) * (729 / 1504));
				min-width: 365px;
				gap: 10px;
				.row {
					&.option {
						font-size: 1rem;
					}
				}

				.body {
					gap: 19.5px;
				}
			}

			.payment-wrapper {
				flex-grow: 775;
				width: calc((100% - 30px) * (775 / 1504));
				min-width: 387px;
				gap: 15px;
				@include appleAdjustTextForSize(16, false);
			}

			.seperate-bar {
				margin: 10px 0px;
			}

			.payment-card {
				display: flex;
				gap: 10px;
				color: #46474b;
				.type,
				.total {
					font-weight: 500;
				}

				.total {
					font-size: 1.25rem;
				}
				img {
					width: 40px;
					height: 30px;
					object-fit: contain;
				}

				.payment-info-wrapper {
					justify-content: space-between;
					gap: 13px;
					.type,
					.total {
						@include appleAdjustTextForSize(20, false);
						@include heightRelativeToFontSize(24);
					}

					.type {
						min-width: 100px;
						flex-basis: auto;
					}

					.total {
						flex-basis: auto;
						order: 2;
					}
					.card-no {
						order: 3;
					}
				}
			}
			.total-receipt {
				.grand-total {
					@include appleAdjustTextForSize(20, false);
				}
			}
		}
	}

</style>
